<!-- SwipFx Orders Page - Filterable Order Book (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">

    <app-header [page]="'Accounts'"></app-header>
<main class="container py-4">

  <div class="d-flex justify-content-between align-items-center mb-3">
    <div>
      <h4 class="fw-bold mb-0">Verification</h4>
      <div class="text-muted small">Manage your KYC applications</div>
    </div>

    <button class="btn btn-primary btn-sm" (click)="startNew()">
      Start New
    </button>
  </div>

  <div *ngIf="loading" class="text-center py-4">
    <div class="spinner-border"></div>
  </div>

  <div *ngIf="error" class="alert alert-danger">
    {{ error }}
  </div>

  <div *ngIf="!loading && applications.length === 0" class="text-center py-5 text-muted">
    No applications yet.
  </div>

  <div *ngIf="applications.length > 0" class="card shadow-sm">
    <div class="table-responsive">
      <table class="table table-hover align-middle mb-0">

        <thead class="table-light">
          <tr>
            <th>Country</th>
            <th>Tier</th>
            <th>Status</th>
            <th>Started</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let app of applications">
            <td>
              <div class="fw-semibold">{{ app.jurisdictionCode }}</div>
              <div class="small text-muted">{{ app.customerType }}</div>
            </td>

            <td>{{ app.tierCode }}</td>

            <td>
              <span class="badge" [ngClass]="getStatusClass(app.status)">
                {{ getStatusLabel(app.status) }}
              </span>
            </td>

            <td>{{ app.startedAt | date:'medium' }}</td>

            <td class="text-end">
                <button class="btn btn-sm btn-outline-primary"
                        (click)="open(app)">
                    View
                </button>

                <button *ngIf="canDelete(app)"
                        class="btn btn-sm btn-outline-danger"
                        [disabled]="deleteBusyId === app.applicationId"
                        (click)="delete(app)">
                    <span *ngIf="deleteBusyId === app.applicationId" class="spinner-border spinner-border-sm me-2"></span>
                    Delete
                </button>
            </td>
          </tr>
        </tbody>

      </table>
    </div>
  </div>
  <app-footer></app-footer>

</main>
</div>
